(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/progress-bar-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/progress-bar-container.js');

'use strict';

var _svs$lyckoplatsen$dat;
const {
  useState,
  useCallback,
  useEffect,
  useRef,
  useMemo
} = React;
const {
  ProgressBar
} = svs.numbergames.progress_bar;
const {
  isExaminedAtom
} = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms;
const {
  correctionStepAtom,
  correctionTriggerTypeAtom,
  selectedResultAtom,
  isLatestResultAtom,
  playCorrectionTlAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  useAtomValue,
  useAtom
} = jotai;
const {
  CONSTANTS: {
    CORRECTION_STEP,
    CORRECTION_TRIGGER_TYPE
  }
} = svs.lyckoplatsen.components.shared_constants;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const resultLatest = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.result_latest;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const indexStepMap = {
  48: {
    [CORRECTION_STEP.TOPWIN]: 0,
    [CORRECTION_STEP.PLACE]: 1,
    [CORRECTION_STEP.DISTANCE]: 2
  },
  49: {
    [CORRECTION_STEP.PLACE]: 0,
    [CORRECTION_STEP.DISTANCE]: 1
  }
};
const productName = 'lyckoplatsen';
const trackingCategory = 'result-lyckoplatsen';
const ProgressBarContainer = _ref => {
  let {
    isResult = false
  } = _ref;
  const result = useAtomValue(selectedResultAtom);
  const isExamined = useAtomValue(isExaminedAtom);
  const [isLatestResult, setIsLatestResult] = useAtom(isLatestResultAtom);
  const [correctionTriggerType, setCorrectionTriggerType] = useAtom(correctionTriggerTypeAtom);
  const [correctionStep, setCorrectionStep] = useAtom(correctionStepAtom);
  const [playCorrectionTl, setPlayCorrectionTl] = useAtom(playCorrectionTlAtom);
  const [correctionTlStarted, setCorrectionTlStarted] = useState(false);
  const [stepEnded, setStepEnded] = useState(false);
  const [stepStarted, setStepStarted] = useState(false);
  const ref = useRef();
  const [animationComplete, setAnimationComplete] = useState(false);
  const START_STEP = productMapping.isLyckoplatsenPrimary(result.productId) ? CORRECTION_STEP.TOPWIN : CORRECTION_STEP.PLACE;
  const allSteps = useMemo(() => {
    const steps = [{
      title: 'Plats',
      step: CORRECTION_STEP.PLACE
    }, {
      title: 'Avstånd',
      step: CORRECTION_STEP.DISTANCE
    }, {
      title: 'Resultat',
      step: CORRECTION_STEP.RESULT
    }];
    if (productMapping.isLyckoplatsenPrimary(result.productId)) {
      return [{
        title: 'Toppvinst',
        step: CORRECTION_STEP.TOPWIN
      }, ...steps];
    }
    return steps;
  }, [result]);
  const stepIndex = useMemo(() => {
    var _indexStepMap$result$, _indexStepMap$result$2;
    if (correctionStep === CORRECTION_STEP.RESULT) {
      return allSteps.length - 1;
    }
    return (_indexStepMap$result$ = (_indexStepMap$result$2 = indexStepMap[result.productId]) === null || _indexStepMap$result$2 === void 0 ? void 0 : _indexStepMap$result$2[correctionStep]) !== null && _indexStepMap$result$ !== void 0 ? _indexStepMap$result$ : 0;
  }, [correctionStep, result, allSteps]);
  const [activeStepIndex, setActiveStepIndex] = useState(stepIndex);
  const hide = useMemo(() => isResult ? isLatestResult && correctionStep === START_STEP && !correctionTlStarted : !isExamined && correctionStep === START_STEP && !correctionTlStarted, [isResult, isLatestResult, correctionStep, START_STEP, correctionTlStarted, isExamined]);
  useEffect(() => {
    setIsLatestResult(!isSelfService && result.drawNumber === (resultLatest === null || resultLatest === void 0 ? void 0 : resultLatest.drawNumber));
  }, [result.drawNumber, setIsLatestResult]);

  useEffect(() => {
    setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.CLICK);
  }, [result]);

  useEffect(() => {
    if ((stepIndex === 0 || stepIndex === allSteps.length - 1) && correctionTriggerType !== CORRECTION_TRIGGER_TYPE.AUTOMATED) {
      setActiveStepIndex(stepIndex);
    }
  }, [allSteps.length, correctionTriggerType, stepIndex, result]);
  useEffect(() => {
    if (playCorrectionTl && !correctionTlStarted) {
      setCorrectionTlStarted(true);
    }
  }, [playCorrectionTl, correctionTlStarted]);
  useEffect(() => {
    if (correctionStep === START_STEP || correctionStep === CORRECTION_STEP.RESULT) {
      setPlayCorrectionTl(false);
      setCorrectionTlStarted(false);
      setStepStarted(false);
    }
  }, [correctionStep, START_STEP, setPlayCorrectionTl]);
  useEffect(() => {
    if (correctionTlStarted) {
      setStepStarted(true);
    }
  }, [activeStepIndex, correctionTlStarted]);

  useEffect(() => {
    if (correctionTriggerType === CORRECTION_TRIGGER_TYPE.AUTOMATED && correctionTlStarted) {
      setStepStarted(false);
      setTimeout(() => {
        setStepEnded(true);
      }, 200);
    }
  }, [correctionStep, correctionTriggerType, correctionTlStarted, setCorrectionTriggerType]);
  useEffect(() => {
    if (hide) {
      gsap.set(ref.current, {
        opacity: 0,
        height: 0
      });
    } else {
      gsap.to(ref.current, {
        opacity: 1,
        height: 'auto',
        duration: 0.5
      });
    }
  }, [hide]);
  const handleStepClick = useCallback(stepIndex => {
    if (activeStepIndex === stepIndex) {
      return;
    }
    setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.CLICK);
    setActiveStepIndex(stepIndex);
    setCorrectionStep(allSteps[stepIndex].step);
    setStepEnded(false);
  }, [activeStepIndex, setCorrectionTriggerType, setCorrectionStep, allSteps]);

  useEffect(() => {
    if (animationComplete) {
      setActiveStepIndex(stepIndex);
      setStepEnded(false);
      setAnimationComplete(false);
    }
  }, [stepIndex, animationComplete, START_STEP, allSteps.length]);
  if (isSelfService) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-progress-bar-container gsap-progress-bar-container ".concat(hide ? '--init-hide' : ''),
    ref: ref
  }, React.createElement(ProgressBar, {
    activeStepIndex: activeStepIndex,
    onStepClick: handleStepClick,
    productName: productName,
    steps: allSteps,
    trackingCategory: trackingCategory,
    duration: "1s",
    isActiveStepProgressComplete: stepEnded,
    isActiveStepProgressStarted: stepStarted,
    onProgressBarAnimationEnd: () => setAnimationComplete(true),
    displayShowDirect: false
  }));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ProgressBarContainer
});

 })(window);